import { AxiosError } from 'axios';
import { useRef, useState } from 'react';
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useClickAway } from 'react-use';
import { ErrorInfo, TreeCompany } from '../../../../api/model';
import { usePostOrganizationsCheck } from '../../../../api/origanization/origanization';
import { useDefaultOptions } from '../../../../hooks/api';
import OkModal from '../../../modules/OkModal';
import { TeamModal } from './TeamModal';

type Props = {
  companyIndex: number;
  groupIndex: number;
  teamIndex: number;
  teamSize: number;
  setValue: UseFormSetValue<{ companies: TreeCompany[] }>;
  getValues: UseFormGetValues<{ companies: TreeCompany[] }>;
};
function Team({ teamSize, companyIndex, groupIndex, teamIndex, getValues, setValue }: Props) {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [display, setDisplay] = useState(false);
  const [isTeeamModal, setIsTeamModal] = useState(false);
  const [isCheckError, setIsCheckError] = useState(false);
  const ref = useRef(null);
  useClickAway(ref, () => {
    setDisplay(false);
  });

  const company = getValues().companies[companyIndex] || {};
  const group = (company.groups && company.groups[groupIndex]) || null;
  const team = (group?.teams && group.teams[teamIndex]) || null;

  const options = useDefaultOptions(language);
  const { mutateAsync, error } = usePostOrganizationsCheck<AxiosError<ErrorInfo>, unknown>(options);

  const handleHidden = async () => {
    await mutateAsync(
      {
        data: { organization_divisions: 3, hidden_id: team?.team_id },
      },
      {
        onSuccess: () => {
          setValue(
            `companies.${companyIndex}.groups.${groupIndex}.teams.${teamIndex}.hidden`,
            team?.hidden === 0 ? 1 : 0
          );
        },
        onError: () => {
          setIsCheckError(true);
        },
      }
    );
  };

  const handleContextMenu = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e.preventDefault();
    setDisplay(true);
  };

  if (!team) return null;

  return (
    <div key={`team-${String(team.team_id)}`} className={`${teamSize === 1 ? 'bgnone' : ''}`}>
      <div id="group" ref={ref}>
        <p
          className={`name ${team.hidden === 1 ? 'grayoff' : ''}`}
          style={{ cursor: 'pointer' }}
          onContextMenu={(e) => handleContextMenu(e)}
        >
          {team.team_name_ja}
        </p>
        <ul className="pop" style={{ display: display ? 'block' : 'none', width: '120px' }}>
          <li onClick={() => setIsTeamModal(true)}>
            <i className="fa-solid fa-pen-to-square" />
            {t('チーム編集')}
          </li>
          <li onClick={() => handleHidden()}>
            <i className="fa-solid fa-eye-slash" />
            {team?.hidden === 0 ? t('チーム非表示') : t('チーム表示')}
          </li>
          <li />
        </ul>
      </div>

      <TeamModal
        companyIndex={companyIndex}
        groupIndex={groupIndex}
        teamIndex={teamIndex}
        open={isTeeamModal}
        onClose={() => setIsTeamModal(false)}
        getValues={getValues}
        setValue={setValue}
      />

      {isCheckError && <OkModal onClickOk={() => setIsCheckError(false)}>{error?.response?.data?.message}</OkModal>}
    </div>
  );
}

export { Team };
